import React from "react";

import {
  THead,
  TrHead,
  TBody,
  Th,
  Tr,
  Td,
  InnerCell,
} from "@teamrota/rota-design";

import {
  formatDateMonthTimeShort,
  formatHoursMinutes,
} from "~/src/utils/formatting";
import Icon from "~/src/components/icon";
import { EmptyText, IconDiv } from "~/src/components/payroll/style";
import IconLink from "~/src/containers/payroll/components/IconLink";
import { ScrollableTable } from "../styles";
import { COL_WIDTHS } from ".";
import { getFillText } from "../../utils";
import StreamInfoModal from "./modal";

interface TableProps {
  streams: any[];
  loading: boolean;
}

const Table: React.FC<TableProps> = ({ streams, loading }) => {
  const [selectedStreamId, setSelectedStreamId] = React.useState<number | null>(
    null,
  );

  return (
    <>
      <ScrollableTable colWidths={COL_WIDTHS}>
        <THead>
          <TrHead>
            <Th>ID</Th>
            <Th>Client</Th>
            <Th>Venue</Th>
            <Th>Role</Th>
            <Th>Date/Time</Th>
            <Th>State</Th>
            <Th>Filled</Th>
            <Th>&nbsp;</Th>
          </TrHead>
        </THead>

        <TBody className="streams-table-scroll-body">
          {!loading && streams?.length ? (
            streams.map((stream: any) => (
              <Tr key={stream.id}>
                <Td>
                  <InnerCell
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <span style={{ width: "4vw" }}>#{stream.id}</span>

                    <img
                      title={stream.account.name}
                      src={`/images/shiftstream/${stream.account.provider}.png`}
                      alt={`${stream.account.provider} logo`}
                      style={{ height: 20, verticalAlign: "middle" }}
                    />
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    {stream.shift.sourceAccount.accountName}
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    {stream.shift.venue.name}

                    {stream.shift.subvenue?.name && (
                      <div style={{ fontSize: "80%" }}>
                        ({stream.shift.subvenue.name})
                      </div>
                    )}
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>{stream.shift.role.name}</InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    <span style={{ whiteSpace: "nowrap" }}>
                      {formatDateMonthTimeShort(stream.shift.startTime)} -{" "}
                      {formatHoursMinutes(stream.shift.endTime)}
                    </span>
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>{stream.state}</InnerCell>
                </Td>

                <Td>
                  <InnerCell>{getFillText(stream)}</InnerCell>
                </Td>

                <Td>
                  <IconDiv>
                    <IconLink
                      name="MORE"
                      size={25}
                      isButton
                      color={Icon.colors.MAIN_ORANGE}
                      tooltip="Actions"
                      onClick={() => setSelectedStreamId(stream.id)}
                    />
                  </IconDiv>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan={7}>
                <EmptyText>
                  {!loading && "None found 👀"}
                  {loading && "Loading... ⏳"}
                </EmptyText>
              </Td>
            </Tr>
          )}
        </TBody>
      </ScrollableTable>

      <StreamInfoModal
        streamId={selectedStreamId}
        onClose={() => setSelectedStreamId(null)}
      />
    </>
  );
};

export default Table;
